import React from 'react';

import FinishContentLayout from './FinishContentLayout';

function MemberFinishContentSP(props) {
  return <FinishContentLayout {...props} />;
}

export default MemberFinishContentSP;
